// Phase 5 — Verknüpfte Tickets. Link types + the German computed-inverse labels
// that mirror the backend (app/db/models/ticket_link.py). Pure, unit-tested.

export type LinkType = "related" | "duplicate" | "reference" | "follow_up";
export type LinkDirection = "outgoing" | "incoming";

// The peer relations a user can pick in the Verknüpfen dialog (follow_up is created
// via the separate Folgeticket flow, not chosen here).
export const RELATION_TYPES: { value: LinkType; label: string }[] = [
  { value: "related", label: "Hängt zusammen mit" },
  { value: "duplicate", label: "Duplikat von" },
  { value: "reference", label: "Verweist auf" },
];

const LABELS: Record<LinkType, { outgoing: string; incoming: string }> = {
  related: { outgoing: "Hängt zusammen mit", incoming: "Hängt zusammen mit" },
  duplicate: { outgoing: "Duplikat von", incoming: "Hat Duplikat" },
  reference: { outgoing: "Verweist auf", incoming: "Referenziert von" },
  follow_up: { outgoing: "Folgeticket von", incoming: "Hat Folgeticket" },
};

/** The relation label to show on one end of a link, given its direction. */
export function linkLabel(type: LinkType, direction: LinkDirection): string {
  return LABELS[type][direction];
}
